import { axios } from 'lib/axios';
import { useQuery } from 'react-query';

export const getDeposits = async ({ currencyId, pageNumber = 1 }) => {
  if (!currencyId) return Promise.resolve([]); // Prevent API call if currencyId is undefined
  console.log('Fetching deposits for:', { currencyId, pageNumber });
  return axios.get(`/transaction/deposit/${currencyId}/${pageNumber}`);
};

export const useDeposits = ({ currencyId, pageNumber = 1, config }) => {
  return useQuery({
    ...config,
    queryKey: ['deposits', currencyId, pageNumber], // ✅ Query key now includes currencyId
    queryFn: () => getDeposits({ currencyId, pageNumber }),
    enabled: !!currencyId, // ✅ Prevents execution if currencyId is null/undefined
  });
};
